var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('DoctorQueueTable',{attrs:{"permission-key":"dental_patients","endpoint":"/dentalpatients","action-path":"/treatment","action-label":"Treatment","no-permission-text":"You have no permission to View Dental Patients"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }